
import React from 'react';
import ServiceCard from './ServiceCard';
import { ServiceCategory } from '@/types/serviceTypes';

interface ServicesCategorySectionProps {
  category: ServiceCategory;
}

const ServicesCategorySection: React.FC<ServicesCategorySectionProps> = ({ category }) => {
  return (
    <div key={category.id} id={category.id} className="mb-16 scroll-mt-40">
      <div className="mb-10">
        <h2 className="text-3xl font-serif font-bold mb-4 text-pkstone-900 border-b border-pkgreen-100 pb-2">
          {category.name}
        </h2>
        <p className="text-lg text-pkstone-700">
          {category.id === 'lawn-maintenance' && "Comprehensive lawn and garden services to keep your outdoor spaces healthy and beautiful year-round."}
          {category.id === 'landscape-design' && "Creative design solutions that transform your property into a personalized outdoor sanctuary."}
          {category.id === 'hardscaping' && "Durable, beautiful hardscape elements that add structure, function, and value to your landscape."}
          {category.id === 'specialty-services' && "Specialized services to complete your property maintenance needs throughout the seasons."}
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {category.services.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </div>
  );
};

export default ServicesCategorySection;
